@if (!isLoading && !comoUser && (isComoEnabled$ | async)) {
  <app-mosaic-como-long-push-atom
    [heading]="heading ? heading : 'como.already-member'"
    [text]="text ? text : 'como.connect-account'"
    [textColor]="$any(textColor)"
    [backgroundColor]="backgroundColor"
    (click)="onClick()"
  >
  </app-mosaic-como-long-push-atom>
}
